/**
 * Supabase matches `signInWithPassword` email against `auth.users` literally;
 * normalizing avoids false failures when users vary ASCII case (domains are
 * case-insensitive; local parts are treated case-insensitively here for UX).
 */
export function normalizeAuthEmail(email: string): string {
  return email.trim().toLowerCase()
}
